import React from 'react';
import { galleryImages } from '../mock';
import { Heart, ChefHat, Users } from 'lucide-react';

export default function About() {
  return (
    <div className="bg-[#faf6f0] pt-32 pb-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-amber-600 tracking-[0.3em] text-xs uppercase">Unsere Geschichte</span>
          <h1 className="font-serif text-5xl md:text-6xl text-[#1a1410] mt-4">Über uns</h1>
          <div className="w-16 h-[3px] bg-amber-500 mx-auto mt-6"/>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-2xl">
            <img src={galleryImages[0].url} alt="KSV Sportkantine" className="w-full h-full object-cover"/>
          </div>
          <div>
            <h2 className="font-serif text-3xl text-[#1a1410] mb-4">Unser Team</h2>
            <p className="text-[#3d332b] leading-relaxed mb-4">
              Seit vielen Jahren verwöhnt unser engagiertes Team die Gäste der KSV-Sportkantine mit ehrlicher, herzhafter österreichischer Küche. Ob nach dem Sport, mit der Familie oder für eine Feier — bei uns fühlen Sie sich zu Hause.
            </p>
            <p className="text-[#5a4a3d] leading-relaxed">
              Wir legen Wert auf frische Zutaten, klassische Rezepte und einen freundlichen, persönlichen Service. In unserem gemütlichen Ambiente treffen sich Nachbarn, Sportbegeisterte und alle, die gutes Essen schätzen.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: Heart, title: 'Mit Leidenschaft', desc: 'Jedes Gericht wird mit Liebe und Sorgfalt zubereitet.' },
            { icon: ChefHat, title: 'Wiener Tradition', desc: 'Authentische österreichische Klassiker — Schnitzel, Gansl, Fingerfood.' },
            { icon: Users, title: 'Für alle da', desc: 'Familien, Vereine, Feiern — wir sind Ihr Treffpunkt in Simmering.' },
          ].map((v, i) => (
            <div key={i} className="bg-white rounded-xl p-8 shadow-sm border border-amber-100">
              <div className="w-14 h-14 rounded-full bg-amber-500 text-white flex items-center justify-center mb-4"><v.icon size={26}/></div>
              <h3 className="font-serif text-xl text-[#1a1410] mb-2">{v.title}</h3>
              <p className="text-[#5a4a3d]">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-16">
          {galleryImages.slice(1, 5).map((g) => (
            <div key={g.id} className="aspect-square rounded-lg overflow-hidden group">
              <img src={g.url} alt={g.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
